import { httpss } from "../utils/host";

export const claimDailyTurnRoute = `${httpss}/apis_v1/tree-watering/claim-daily-turn`;
export const checkDailyTurnRoute = `${httpss}/apis_v1/tree-watering/check-daily-turn`;
export const waterTreeRoute = `${httpss}/apis_v1/tree-watering/water-tree`;
export const getUserTreeInfoRoute = `${httpss}/apis_v1/tree-watering/user-info`;
export const getUserRewardsRoute = `${httpss}/apis_v1/tree-watering/user-rewards`;
export const getUserStatisticsRoute = `${httpss}/apis_v1/tree-watering/user-statistics`;
export const getLeaderboardRoute = `${httpss}/apis_v1/tree-watering/leaderboard`;
export const getTop3Route = `${httpss}/apis_v1/tree-watering/top3`;
export const getTop10SubmissionsRoute = `${httpss}/apis_v1/tree-watering/top10-submissions`;
export const getTop10RewardsRoute = `${httpss}/apis_v1/tree-watering/top10-rewards`;
export const getRewardsRoute = `${httpss}/apis_v1/tree-watering/rewards`;
export const exportRewardsJSONRoute = `${httpss}/apis_v1/tree-watering/rewards/export-json`;
